import { configureStore } from '@reduxjs/toolkit'
import appReducer from './reducer'
import languageReducer from "../../src/Redux/languageSlice";
import flowReducer from "../Redux/flowSlice";

export default configureStore({
  reducer: {
    user:     appReducer,
    language: languageReducer,
    flow:     flowReducer,
  },
})